import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const featured = dramas.filter((item) => item.featured);

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (featured.length <= 1) return;
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % featured.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + featured.length) % featured.length);
  };

  if (featured.length === 0) return null;

  return (
    <section className="relative h-[460px] w-full overflow-hidden md:h-[600px]">
      {featured.map((item, i) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === active ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <div className="absolute inset-0 h-full w-full">
            <img
              src={item.banner}
              alt={`${item.title} 剧照`}
              title={`${item.title} - 泰国双男主热播剧推荐`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 flex h-full w-full items-center px-4 md:px-6">
        <div className="w-full">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-fire-fill"></i>本周焦点推荐
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
              {featured[active].title}
            </h1>
            <p className="mt-2 font-heading text-base font-bold text-primary-200 md:text-lg">
              {featured[active].subtitle}
            </p>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200/90 md:text-base">
              {featured[active].shortIntro}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${featured[active].id}`}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>查看详情
              </Link>
              <Link
                to="/category/热门推荐"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20 cursor-pointer"
              >
                <i className="ri-bookmark-3-line text-lg"></i>更多剧集
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
        {featured.map((item, i) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setActive(i)}
            aria-label={`切换到 ${item.title}`}
            className={`h-2 rounded-full transition-all ${
              i === active ? "w-6 bg-primary-400" : "w-2 bg-background-50/60 hover:bg-background-50"
            }`}
          ></button>
        ))}
      </div>

      <button
        type="button"
        onClick={() => go(-1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 transition-colors hover:bg-foreground-950/60 md:left-6 md:flex"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        onClick={() => go(1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-50/30 bg-foreground-950/30 text-background-50 transition-colors hover:bg-foreground-950/60 md:right-6 md:flex"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}